import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.png';
import { useConsoleTheme } from '../lib/theme';

// Reached from the analytics dashboard's sign-out, so one click ends both
// sessions. Signs out on arrival, then offers the way back in.
export default function Logout() {
  const { logout } = useAuth();
  const [done, setDone] = useState(false);
  useConsoleTheme(); // marks <html> with the console theme while mounted

  useEffect(() => {
    let alive = true;
    logout().finally(() => {
      if (alive) setDone(true);
    });
    return () => {
      alive = false;
    };
  }, [logout]);

  return (
    <div className="portal-skin min-h-screen relative flex items-center justify-center px-6">
      <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
        <div className="absolute inset-0 grain-bg opacity-[0.13]" />
      </div>
      <div className="relative z-[1] w-full max-w-md p-8 md:p-10 rounded-2xl bg-white/[0.025] backdrop-blur-sm border border-white/[0.06] text-center">
        <img src={logo} alt="NexSav" data-light-invert className="h-10 w-auto mx-auto mb-6 opacity-90" />
        <h1 className="text-2xl font-semibold text-white tracking-tight">
          {done ? 'You are signed out.' : 'Signing you out.'}
        </h1>
        <p className="text-sm text-gray-500 mt-2">Your portal session has ended on this browser.</p>
        <Link
          to="/login"
          className="mt-7 inline-flex items-center justify-center w-full px-6 py-3.5 rounded-full bg-[#B0FC38] text-gray-900 text-sm font-semibold hover:bg-[#9BE22E] transition-all"
        >
          Sign in again
        </Link>
      </div>
    </div>
  );
}
